<div class="cx-one-ui cxone-custom-data-import-container" id="data-import-container">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <!--This section will be displayed when user is on listing view-->
    <div class="list-section" *ngIf="!showViewDetailsPage" id="data-import-list-section">
        <div class="header" id="data-import-list-header">
            <span class="label" id="import-data-title" data-qa="cxone-etl-custom-data-import-title" cvLocalizedText langSection="CXone_Custom_Data_Import"
                langKey="Import_Data">Import Data</span>
            <button id="import-btn" (click)="showImportDialog()" class="cxone-btn btn-big btn-primary"
                tabindex="0" *ngIf="showImportBtn">Import</button>
        </div>

        <div class="table-container" id="table-container">
            <!-- Actual Table container  -->
            <cxone-omnibar [itemCountLabel]="dataImportLabel" [isFilterable]="false" id="table-omnibar"
                [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
                [searchQuery]="searchInput">
            </cxone-omnibar>
            <cxone-grid id="cxone-grid" [gridOptions]="dataImportGridOptions" *ngIf="dataImportGridOptions && dataImportGridOptions.hasOwnProperty('columnDefs')">
            </cxone-grid>
        </div>
    </div>

    <!-- This section will be displayed when user is on Preview view -->
    <div class="preview-section" *ngIf="showViewDetailsPage" id="view-section">
        <cv-cxone-custom-data-import-view id="data-import-viewPage" [importViewData]="importViewData"
            [rawDataDefinitions]="rawDataDefinitions" (backButtonClick)="showHideViewPage($event)">
        </cv-cxone-custom-data-import-view>
    </div>
</div>